import { observable, computed, action } from 'mobx';
import { IGalleryPicture, IPicture } from './../../../common/interfaces/picture';

export class Picture {

    @observable public lastImageId: number = 0;

    @observable public images: IGalleryPicture[] = [];

    @computed private get imagesIds(): number[] {
        return this.images.map((image) => image.id);
    }

    @action public showImage = (image: IPicture) => {
        const imageId = this.lastImageId + 1;

        this.images.push({
            ...image,
            id: imageId
        });

        this.lastImageId = imageId;
    }

    @action public hideImage = (imageId: number) => {
        const imageFound = this.imagesIds.indexOf(imageId);

        if (imageFound !== -1) {
            this.images.splice(imageFound, 1);
        }
    }

    @action public hideAllImages = () => {
        this.images = [];
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/stores/Picture.ts